
import { Component, Vue } from 'vue-property-decorator';
import { LocalStorageKeys } from '@/types/LocalStorageKeys';

@Component
export default class MapHelpPopup extends Vue {
  showMapPopup = false;

  mounted() {
    if (
      !localStorage.getItem(LocalStorageKeys.CWCB_DISMISS_MAP_HELP_NOTIFICATION)
    ) {
      localStorage.setItem(
        LocalStorageKeys.CWCB_DISMISS_MAP_HELP_NOTIFICATION,
        'false',
      );
    }

    if (
      localStorage.getItem(
        LocalStorageKeys.CWCB_DISMISS_MAP_HELP_NOTIFICATION,
      ) === 'true'
    ) {
      this.showMapPopup = false;
    } else {
      this.showMapPopup = true;
    }
  }

  hideCard() {
    this.showMapPopup = false;
  }

  get boxValue(): boolean {
    const value = localStorage.getItem(
      LocalStorageKeys.CWCB_DISMISS_MAP_HELP_NOTIFICATION,
    );
    return value === 'true' ? true : false;
  }

  set boxValue(newVal: boolean) {
    if (newVal) {
      localStorage.setItem(
        LocalStorageKeys.CWCB_DISMISS_MAP_HELP_NOTIFICATION,
        'true',
      );
    } else {
      localStorage.setItem(
        LocalStorageKeys.CWCB_DISMISS_MAP_HELP_NOTIFICATION,
        'false',
      );
    }
  }

  hideTooltip() {
    this.showMapPopup = false;
  }
}
